import { createContext, useContext, useState, useEffect } from "react";

const I18nCtx = createContext({ lang: "es", setLang: () => {}, t: (k) => k });

const dict = {
  es: {
    "scarcity.bar": "Acceso completo · 7 días por $1 USD · cupos limitados este mes",
    "nav.features": "Funciones",
    "nav.how": "Cómo",
    "nav.pricing": "Precios",
    "nav.faq": "FAQ",
    "nav.login": "Entrar",
    "nav.register": "Probar por $1",
    "hero.badge": "Asistente con IA · OCR · Binance P2P en vivo",
    "hero.title1": "El dinero que no ves, ",
    "hero.title2": "se te escapa.",
    "hero.title3": "",
    "hero.subtitle": "Un panel. Todas tus cuentas. Cero adivinanzas.",
    "hero.subtitle2": "Multi-divisa, OCR de vouchers y deudas controladas en tiempo real.",
    "hero.cta.primary": "Desbloquear 7 días por $1",
    "hero.cta.secondary": "Ver demo",
    "hero.reassurance": "Cancela cuando quieras  ·  Sin trucos  ·  Día 7 cobramos $4 o $8 (Pro/Familia)",
    "hero.live": "USDT/DOP EN VIVO · Binance P2P",
    "trust.label": "Construido sobre tecnología de nivel banco",
    "trust.stripe": "Pagos por Stripe",
    "trust.encryption": "Cifrado AES-256",
    "trust.bcrypt": "Contraseñas bcrypt",
    "trust.refund": "Cancela antes del día 7",
    "pain.label": "Lo que pierdes hoy",
    "pain.title": "¿Te suena?",
    "pain.1.title": "Mora innecesaria",
    "pain.1.desc": "Olvidaste un pago. Te avisamos 3 días antes.",
    "pain.2.title": "Excel a las 11pm",
    "pain.2.desc": "OCR registra cada voucher en 3 segundos.",
    "pain.3.title": "¿USDT a qué tasa?",
    "pain.3.desc": "Mediana P2P en vivo. Sin tabs ni cálculos.",
    "features.label": "Las funciones",
    "features.title1": "Lo que ",
    "features.title2": "reemplaza",
    "features.subtitle": "5 apps + Excel + tu memoria, en un panel.",
    "how.label": "3 pasos",
    "how.title1": "Listo en ",
    "how.title2": "90 segundos",
    "how.1.title": "Regístrate",
    "how.1.desc": "Email o Google. Acceso completo por $1.",
    "how.2.title": "Configura en 5 pasos",
    "how.2.desc": "Divisa, categorías, presupuesto, cuentas y tarjetas.",
    "how.3.title": "Escanea y olvida",
    "how.3.desc": "Cada gasto entra con una foto. El asistente hace el resto.",
    "social.label": "Resultados reales",
    "social.title1": "Ya optimizan ",
    "social.title2": "su patrimonio",
    "pricing.label": "Oferta de lanzamiento",
    "pricing.title1": "Acceso completo · ",
    "pricing.title2": "$1 los primeros 7 días",
    "pricing.subtitle": "Día 7: $4 (Pro) o $8 (Familia). Cancela en cualquier momento.",
    "pricing.billing.monthly": "Mensual",
    "pricing.billing.yearly": "Anual",
    "pricing.save": "-20%",
    "pricing.special": "$1 · 7 días",
    "pricing.free.name": "Free",
    "pricing.free.desc": "Para empezar a explorar.",
    "pricing.pro.name": "Pro",
    "pricing.pro.desc": "Todo desbloqueado para tu economía personal.",
    "pricing.family.name": "Familia",
    "pricing.family.desc": "Tú, tu pareja y gastos compartidos.",
    "pricing.cta.free": "Continuar con Free",
    "pricing.cta.special": "Desbloquear por $1",
    "pricing.cta.try": "Suscribirme",
    "pricing.guarantee": "Cancela antes del día 7 y no se te cobra nada más.",
    "faq.label": "Preguntas frecuentes",
    "faq.title1": "Lo que ",
    "faq.title2": "necesitas saber",
    "final.title1": "Tu dinero se mueve",
    "final.title2": "con o sin ti.",
    "final.subtitle": "Empieza a verlo todo en un solo lugar. Hoy por $1.",
    "final.cta": "Desbloquear 7 días por $1",
    "final.urgency": "+1,247 personas activaron acceso este mes",
    "footer.tagline": "The Trading Dock® · Pryma Wellness Group Inc.",
    "footer.legal": "© 2026 Pryma Wellness Group Inc. (Delaware, EE. UU.) · Todos los derechos reservados",
    "footer.privacy": "Privacidad",
    "footer.terms": "Términos",
    "footer.contact": "Contacto",
    "feat.ocr.title": "OCR de recibos · IA",
    "feat.ocr.desc": "Foto del voucher → GPT-5.2 extrae monto, fecha, comercio y categoría.",
    "feat.multi.title": "Multi-divisa en vivo",
    "feat.multi.desc": "DOP, USD, EUR, USDT + 6 más. P2P real al instante.",
    "feat.assistant.title": "Asistente del día",
    "feat.assistant.desc": "\"Multi Card cierra hoy. Edenorte en 3 días. USDT +0.4%.\"",
    "feat.cards.title": "Tarjetas inteligentes",
    "feat.cards.desc": "Bancos, corte, pago, sobregiro y multimoneda. Alertas antes del vencimiento.",
    "feat.debts.title": "Deudas con 4 abonos",
    "feat.debts.desc": "Cuenta, débito, crédito o efectivo. Balances ajustados automáticamente.",
    "feat.recurring.title": "Recurrentes y subs",
    "feat.recurring.desc": "Si no pagaste el mes pasado, se genera la deuda automática.",
    "feat.recon.title": "Conciliación bancaria",
    "feat.recon.desc": "Sube el CSV del banco. Cruzamos e importamos lo que falta.",
    "feat.budgets.title": "Presupuestos y metas",
    "feat.budgets.desc": "Avisos al 90% y rojo si te pasas. Sin sorpresas.",
    "feat.privacy.title": "Privacidad blindada",
    "feat.privacy.desc": "JWT cifrado, bcrypt, HTTPS. Tu data en tu espacio.",
    "test.1.text": "Cobro en USD y gasto en pesos. La app me dice exactamente cuánto vale mi patrimonio. Adiós calculadora.",
    "test.1.role": "Diseñador freelance · RD$ + USD",
    "test.2.text": "Mi esposo gana USD y yo DOP. Ver los dos balances juntos cambió cómo planificamos en familia.",
    "test.2.role": "Madre + emprendedora",
    "test.3.text": "USDT/DOP en vivo + comisiones LBTR automáticas. Me ahorra 30 min al día.",
    "test.3.role": "Trader cripto",
    "hero.cta.dollar": "Desbloquear 7 días por $1",
    "pricing.free.features": "2 cuentas|30 transacciones/mes|5 escaneos OCR/mes|Multi-divisa básico|1 tarjeta",
    "pricing.pro.features": "Cuentas ilimitadas|Transacciones ilimitadas|OCR ilimitado|Asistente del día con IA|Tarjetas ilimitadas|Conciliación CSV|USDT P2P en vivo",
    "pricing.family.features": "Todo lo del Pro|Hasta 4 usuarios|Presupuestos compartidos|Multi-divisa por miembro|Reportes consolidados|Soporte prioritario",
    "pricing.period.first": "$1 · 7 días",
    "pricing.period.month": "/mes",
    "pricing.period.yearly": "/mes · cobro anual",
    "pricing.badge.bestseller": "Más vendido",
    "pricing.badge.popular": "Recomendado",
  },
  en: {
    "scarcity.bar": "Full access · 7 days for $1 USD · limited spots this month",
    "nav.features": "Features",
    "nav.how": "How",
    "nav.pricing": "Pricing",
    "nav.faq": "FAQ",
    "nav.login": "Log in",
    "nav.register": "Try for $1",
    "hero.badge": "AI assistant · Receipt OCR · Live Binance P2P",
    "hero.title1": "Money you can't see, ",
    "hero.title2": "slips away.",
    "hero.title3": "",
    "hero.subtitle": "One panel. All your accounts. Zero guesswork.",
    "hero.subtitle2": "Multi-currency, receipt OCR and debts controlled in real time.",
    "hero.cta.primary": "Unlock 7 days for $1",
    "hero.cta.secondary": "See demo",
    "hero.reassurance": "Cancel anytime  ·  No tricks  ·  Day 7 we charge $4 or $8 (Pro/Family)",
    "hero.live": "USDT/DOP LIVE · Binance P2P",
    "trust.label": "Built on bank-grade tech",
    "trust.stripe": "Payments by Stripe",
    "trust.encryption": "AES-256 encryption",
    "trust.bcrypt": "bcrypt passwords",
    "trust.refund": "Cancel before day 7",
    "pain.label": "What you lose today",
    "pain.title": "Sound familiar?",
    "pain.1.title": "Unnecessary late fees",
    "pain.1.desc": "You forgot a payment. We remind you 3 days before.",
    "pain.2.title": "Excel at 11pm",
    "pain.2.desc": "OCR logs every voucher in 3 seconds.",
    "pain.3.title": "USDT at what rate?",
    "pain.3.desc": "Live P2P median. No tabs, no math.",
    "features.label": "Features",
    "features.title1": "What ",
    "features.title2": "it replaces",
    "features.subtitle": "5 apps + Excel + your memory, in one panel.",
    "how.label": "3 steps",
    "how.title1": "Ready in ",
    "how.title2": "90 seconds",
    "how.1.title": "Sign up",
    "how.1.desc": "Email or Google. Full access for $1.",
    "how.2.title": "5-step setup",
    "how.2.desc": "Currency, categories, budget, accounts and cards.",
    "how.3.title": "Snap and forget",
    "how.3.desc": "Every expense enters with a photo. Assistant handles the rest.",
    "social.label": "Real results",
    "social.title1": "Already optimizing ",
    "social.title2": "their net worth",
    "pricing.label": "Launch offer",
    "pricing.title1": "Full access · ",
    "pricing.title2": "$1 for 7 days",
    "pricing.subtitle": "Day 7: $4 (Pro) or $8 (Family). Cancel anytime.",
    "pricing.billing.monthly": "Monthly",
    "pricing.billing.yearly": "Yearly",
    "pricing.save": "-20%",
    "pricing.special": "$1 · 7 days",
    "pricing.free.name": "Free",
    "pricing.free.desc": "To start exploring.",
    "pricing.pro.name": "Pro",
    "pricing.pro.desc": "Everything unlocked for your personal economy.",
    "pricing.family.name": "Family",
    "pricing.family.desc": "You, your partner, shared expenses.",
    "pricing.cta.free": "Continue with Free",
    "pricing.cta.special": "Unlock for $1",
    "pricing.cta.try": "Subscribe",
    "pricing.guarantee": "Cancel before day 7 and you won't be charged again.",
    "faq.label": "FAQ",
    "faq.title1": "What you ",
    "faq.title2": "need to know",
    "final.title1": "Your money moves",
    "final.title2": "with or without you.",
    "final.subtitle": "Start seeing it all in one place. Today for $1.",
    "final.cta": "Unlock 7 days for $1",
    "final.urgency": "+1,247 people activated access this month",
    "footer.tagline": "The Trading Dock® · Pryma Wellness Group Inc.",
    "footer.legal": "© 2026 Pryma Wellness Group Inc. (Delaware, USA) · All rights reserved",
    "footer.privacy": "Privacy",
    "footer.terms": "Terms",
    "footer.contact": "Contact",
    "feat.ocr.title": "AI receipt OCR",
    "feat.ocr.desc": "Photo of voucher → GPT-5.2 extracts amount, date, merchant, category.",
    "feat.multi.title": "Live multi-currency",
    "feat.multi.desc": "DOP, USD, EUR, USDT + 6 more. Real P2P instantly.",
    "feat.assistant.title": "Daily assistant",
    "feat.assistant.desc": "\"Multi Card closes today. Edenorte in 3 days. USDT +0.4%.\"",
    "feat.cards.title": "Smart cards",
    "feat.cards.desc": "Issuers, cut-off, payment, overdraft and multi-currency. Alerts before due.",
    "feat.debts.title": "Debts · 4 payment methods",
    "feat.debts.desc": "Account, debit, credit or cash. Balances adjusted automatically.",
    "feat.recurring.title": "Recurring + subs",
    "feat.recurring.desc": "Missed last month? The debt is auto-generated.",
    "feat.recon.title": "Bank reconciliation",
    "feat.recon.desc": "Upload bank CSV. We cross-reference and import what's missing.",
    "feat.budgets.title": "Budgets & goals",
    "feat.budgets.desc": "Alerts at 90% and red if you exceed. No surprises.",
    "feat.privacy.title": "Privacy first",
    "feat.privacy.desc": "JWT encrypted, bcrypt, HTTPS. Your data, your space.",
    "test.1.text": "I earn USD and spend pesos. Now the app tells me exactly what my net worth is. Goodbye calculator.",
    "test.1.role": "Freelance designer · DOP + USD",
    "test.2.text": "My husband earns USD and I earn DOP. Seeing both balances together changed how we plan.",
    "test.2.role": "Mom + entrepreneur",
    "test.3.text": "Live USDT/DOP + automatic LBTR fees saves me 30 min a day.",
    "test.3.role": "Crypto trader",
    "hero.cta.dollar": "Unlock 7 days for $1",
    "pricing.free.features": "2 accounts|30 transactions/mo|5 OCR scans/mo|Basic multi-currency|1 card",
    "pricing.pro.features": "Unlimited accounts|Unlimited transactions|Unlimited OCR|Daily AI assistant|Unlimited cards|CSV reconciliation|Live USDT P2P",
    "pricing.family.features": "Everything in Pro|Up to 4 users|Shared budgets|Per-member multi-currency|Consolidated reports|Priority support",
    "pricing.period.first": "$1 · 7 days",
    "pricing.period.month": "/mo",
    "pricing.period.yearly": "/mo · billed yearly",
    "pricing.badge.bestseller": "Best seller",
    "pricing.badge.popular": "Recommended",
  },
};

const FAQS_ES = [
  { q: "¿Cómo funciona la oferta de $1?", a: "Pagas $1 hoy y tienes acceso completo 7 días. Día 7, si no cancelas, cobramos $4 (Pro) o $8 (Familia) — completando el primer mes. Desde el mes 2: $5 o $9. Cancelas cuando quieras." },
  { q: "¿Mi información bancaria está segura?", a: "Tus datos viven en una base aislada por usuario. JWT cifrado, bcrypt, HTTPS 100%. Pagos por Stripe." },
  { q: "¿Necesito conectar mi banco?", a: "No. Funciona con cualquier banco. Cargas movimientos manualmente, con foto, o importas CSV." },
  { q: "¿Funciona con USDT y cripto?", a: "Sí. USDT↔DOP usa la mediana de Binance P2P en tiempo real." },
  { q: "¿Puedo usarla con mi pareja?", a: "Sí — el plan Familia permite hasta 4 personas con presupuestos compartidos." },
  { q: "¿Funciona en mi teléfono?", a: "Totalmente. Es PWA: en iPhone/Android se instala como app nativa." },
];
const FAQS_EN = [
  { q: "How does the $1 offer work?", a: "You pay $1 today and get full access for 7 days. On day 7, if you don't cancel, we charge $4 (Pro) or $8 (Family) — completing the first month. From month 2: $5 or $9. Cancel anytime." },
  { q: "Is my financial data safe?", a: "Your data lives in an isolated user space. JWT encrypted, bcrypt, 100% HTTPS. Payments by Stripe." },
  { q: "Do I need to connect my bank?", a: "No. Works with any bank. Log movements manually, by photo, or import CSV." },
  { q: "Does it work with USDT/crypto?", a: "Yes. USDT↔DOP uses Binance P2P median in real time." },
  { q: "Can I use it with my partner?", a: "Yes — Family plan allows up to 4 people with shared budgets." },
  { q: "Does it work on my phone?", a: "Fully. It's a PWA: install as a native app on iOS/Android." },
];

export function I18nProvider({ children }) {
  // Default to Spanish regardless of navigator.language — the target market
  // is RD/LATAM and most of the app's own content (LandingPage, AuthPage
  // JSX) is hardcoded Spanish, not routed through t(). Auto-detecting the
  // browser language here caused first-time visitors whose browser reports
  // English (the common default in most environments) to see an English
  // scarcity bar on top of an otherwise all-Spanish page. The explicit
  // ES/EN toggle still works and persists via localStorage.
  const [lang, setLang] = useState(() => {
    return localStorage.getItem("td_lang") || "es";
  });
  useEffect(() => { localStorage.setItem("td_lang", lang); document.documentElement.lang = lang; }, [lang]);
  const t = (k) => dict[lang]?.[k] ?? dict.es[k] ?? k;
  const faqs = lang === "en" ? FAQS_EN : FAQS_ES;
  return <I18nCtx.Provider value={{ lang, setLang, t, faqs }}>{children}</I18nCtx.Provider>;
}

export const useI18n = () => useContext(I18nCtx);
